import React, {FC} from 'react';
import {Button} from 'antd';
import {AuctionType} from '@joyrideautos/ui-models/src/types/auction/Auction';
import {ButtonProps} from 'antd/lib/button';

interface ViewAuctionButtonProps extends ButtonProps {
    auction: AuctionType;
}

const ViewAuctionButton: FC<ViewAuctionButtonProps> = ({auction}) => {
    return (
        <Button data-testid={`auction_card_item_view_button_${auction.auctionSeries}`} size="small" type="primary">
            View
        </Button>
    );
};

export default ViewAuctionButton;
